import React from 'react';
import { useKSK1080_R01Store } from '../Store_KSK1080_R01';

interface SubtotalControlProps {
    className?: string;
}

export const SubtotalControl: React.FC<SubtotalControlProps> = ({ className = '' }) => {
    const { 
        showSubtotals, 
        setShowSubtotals, 
    } = useKSK1080_R01Store();

    const handleToggleSubtotals = () => {
        setShowSubtotals(!showSubtotals);
    };

    return (
        <div className={`flex items-center gap-3 ${className}`}>
            <button
                onClick={handleToggleSubtotals}
                className={`px-4 py-1 rounded-md font-medium transition-colors ${
                    showSubtotals 
                        ? 'bg-blue-100 text-blue-700 hover:bg-blue-200 border border-blue-300' 
                        : 'bg-white text-gray-700 hover:bg-gray-200 border border-gray-300'
                }`}
                title={showSubtotals ? '품목 소계 숨기기' : '품목 소계 표시하기'}
            >
                {showSubtotals ? '품목 소계 숨기기' : '품목 소계 표시'}
            </button>
        </div>
    );
};
